module.exports = __webpack_public_path__ + "img/like.684ec2ff.svg";